import React from "react";
import {inject} from "mobx-react";
import classNames from "classnames";
import {observer} from "mobx-react-lite";
import {Chip, IconButton, InputAdornment, withStyles} from "@material-ui/core";
import {Clear as ClearIcon, Search} from "@material-ui/icons";
import Dialog from "../../../../components/Dialog/Dialog";
import {menuOpcoesPopper} from "../../Constants/Constants";
import InputSearch from "../../../../components/Input/Input";
import CloseIcon from "../../../../components/Icon/CloseIcon";
import PageTitle from "../../../../components/PageTitle/PageTitle";
import {pageConfiguracoes} from "../../../../utils/getPageTitle";
import Auditoria from "../../../../components/Auditoria/Auditoria";
import PopperCustomMenu from "../../../../components/Popper/PopperCustomMenu";
import MultiToggleButtons from "../../../../components/Button/MultiToggleButtons";
import {Button} from "../../../../components/ui/Buttons";
import InputForm from "../../../../components/Input/InputForm";
import TextFieldSearch from "../../../../components/TextField/TextFieldSearch";
import {findAllEspecialidadeMedica} from "../../../../services/AgendamentoService";

const ModalConfiguracoesTabs = observer(
  ({
    classes,
    modalConfiguracoesStore,
    itemSelecionado,
    onClose,
    renderHeader,
    propsTabs,
    children,
    handleSave,
    propsPopperCustom,
    propsTabsAuditoria,
    loadingSave,
    hiddenPopper,
    handleChangeOrientacao,
    handleEspecialidade,
    especialidadesSelecionadas,
    showEspecialidades = false,
    customTabOptions,
    renderCustomTab,
  }) => {
    const handleSelectEspecialidade = (selected) => {
      if (!selected) return;

      const jaExiste = especialidadesSelecionadas.some(esp => esp.id === selected.id);
      if (!jaExiste) {
        const novasEspecialidades = [...especialidadesSelecionadas, selected];
        handleEspecialidade(novasEspecialidades);
      }
    };

    const loadAllEspecialidades = async (search, loadedOptions, { page = 0 }) => {
      const pageableDTO = {
        pageNumber: page,
        pageSize: 10,
        sortDir: 'ASC',
        sortField: 'especialidade',
      };
      const variables = {
        searchDTO: {
          ...pageableDTO,
          search: search || '',
        },
        pageableDTO
      };

      try {
        const response = await findAllEspecialidadeMedica(variables);
        const { content, last } = response;


        return {
          options: content,
          hasMore: !last,
          additional: {
            page: page + 1,
          },
        };
      } catch (error) {
        console.error('Erro ao carregar especialidades:', error);
        return {
          options: [],
          hasMore: false,
        };
      }
    };

    const { titulo, showModal } = modalConfiguracoesStore;
    const modalEdit = itemSelecionado?.id;

    const getPageTitle = () => {
      const acao = modalEdit ? "Novo" : "Editar";
      return pageConfiguracoes(`${acao} ${titulo}`);
    };

    const renderInformacoes = () => (
      <>
        <div className={classes.header}>{renderHeader()}</div>
        <div
          className={classNames(
            classes.content,
            modalEdit && classes.contentEdit
          )}
        >
          <div className={classes.contentTabs}>
            {propsTabs.options && (
              <MultiToggleButtons
                id='cfg-mct-btn-tab'
                options={propsTabs.options}
                tabSelected={propsTabs.tabSelected}
                changeTabSelected={propsTabs.changeTabSelected}
                classes={{ buttonsContainer: classes.buttonsTab }}
                quantidades={propsTabs.quantidades}
              />
            )}

            <InputSearch
              id='cfg-mct-inp-pes'
              startAdornment={
                <InputAdornment position="start">
                  <IconButton
                    id='cfg-mct-btn-pes'
                    className={classes.iconButtonSearch}
                    onClick={propsTabs.handleClickSearch}
                  >
                    <Search />
                  </IconButton>
                </InputAdornment>
              }
              endAdornment={
                propsTabs.valueSearch && (
                  <InputAdornment position="end">
                    <IconButton
                      id='cfg-mct-btn-lim'
                      className={classes.iconButtonSearch}
                      onClick={propsTabs.handleClickClear}
                    >
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                )
              }
              classInputRoot={classes.inputSearch}
              name={"search"}
              placeholder="Pesquisar"
              value={propsTabs.valueSearch}
              onChange={propsTabs.onChangeSearch}
              onKeyPress={propsTabs.onKeypressSearch}
              style={propsTabs.hideSearch ? {display: 'none'} : {}}
            />

            {children}
          </div>
        </div>
      </>
    );

    const renderTabOrientacoes = () => (
      <div className={classes.contentObservacao}>
        <label className={classes.label}>Orientações</label>
       <InputForm
          id='cfg-mct-inp-ori'
          className={classes.observacaoContainer}
          classes={{input:classes.observacao}}
          onChange={handleChangeOrientacao}
          value={itemSelecionado.orientacoes}
          multiline
          rows={20}
          inputProps={{ maxLength: 1000 }}
       />
      </div>
    );

    const renderTabEspecialidades = () => (
      <div className={classes.contentObservacao}>
        <label className={classes.label}>Especialidades</label>
        <div className={classes.especialidadesContainer}>
          <TextFieldSearch
            id='cfg-mct-sel-esp'
            loadOptions={loadAllEspecialidades}
            withPaginate
            placeholder="Selecione as especialidades"
            onChange={(e)=>handleSelectEspecialidade(e)}
            classInput={classes.textFieldSearchInput}
            getOptionLabel={(option)=> option.label || option.especialidade}
            getOptionValue={(option)=> option.id }
            debounceTimeout={300}
            additional={{
              page: 0,
            }}
            menuPosition='fixed'
          />
        </div>
        {especialidadesSelecionadas.length > 0 && (
          <div className={classes.especialidadesListContainer}>
            <p className={classes.especialidadesListTitle}>Especialidades Selecionadas</p>
            <div className={classes.especialidadesList}>
              {especialidadesSelecionadas.map((esp) => (
                <Chip
                  key={esp.id}
                  label={esp.especialidade}
                  onDelete={() => {
                    const novasEspecialidades = especialidadesSelecionadas.filter(e => e.id !== esp.id);
                    handleEspecialidade(novasEspecialidades);
                  }}
                  className={classes.especialidadeChip}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    );

    const renderTabAuditoria = () => (
      <div className={classes.contentAuditoria}>
        <Auditoria />
      </div>
    );

    const renderContentByTab = () => {
      const { tabSelected } = propsTabsAuditoria;

      if (tabSelected === 0) {
        return renderInformacoes();
      }
      if (tabSelected === 1) {
        if (renderCustomTab) return renderCustomTab();
        return renderTabOrientacoes();
      }
      if (customTabOptions && tabSelected === 2) {
        return renderTabOrientacoes();
      }
      if (customTabOptions && tabSelected === 3) {
        return renderTabAuditoria();
      }
      if (!customTabOptions && showEspecialidades && tabSelected === 2) {
        return renderTabEspecialidades();
      }
      if (!customTabOptions && showEspecialidades && modalEdit && tabSelected === 3) {
        return renderTabAuditoria();
      }
      if (!customTabOptions && !showEspecialidades && tabSelected === 2) {
        return renderTabAuditoria();
      }
    };

    const options = customTabOptions ? customTabOptions(modalEdit) : (modalEdit
      ? showEspecialidades
        ? ["Informações", "Orientações", "Especialidades", "Auditoria"]
        : ["Informações", "Orientações", "Auditoria"]
      : showEspecialidades
        ? ["Informações", "Orientações", "Especialidades"]
        : ["Informações", "Orientações"]);
    return (
      <>
        <PageTitle title={getPageTitle()} />
        <Dialog
          open={showModal}
          classes={{
            paper: classes.paper,
            paperScrollPaper: classes.paperScrollPaper,
          }}
          scroll="paper"
          maxWidth="md"
          fullWidth
        >
          <div className={classes.tituloFechar}>
            <span className={classes.titulo}>
              {modalEdit ? `Editar ${titulo}` : `Novo ${titulo}`}
            </span>
            <div className={classes.buttonsHeader}>
              {modalEdit && !hiddenPopper && (
                <PopperCustomMenu
                  id='cfg-mct-pop-aca'
                  colorIcon="#fff"
                  menuOpcoes={menuOpcoesPopper({
                    functions: {
                      handleEdit: () =>
                        propsPopperCustom.handleEditar(itemSelecionado?.id),
                      handleDuplicar: () =>
                        propsPopperCustom.handleDuplicar(itemSelecionado?.id),
                      handleDesativar: () =>
                        propsPopperCustom.handleDesativar(itemSelecionado?.id),
                      handleAtivar: () =>
                        propsPopperCustom.handleAtivar(itemSelecionado?.id),
                    },
                    desativado: !itemSelecionado.ativo,
                    isEdit: false,
                    idPrefix: 'cfg-mct',
                    rowId: itemSelecionado?.id,
                  })}
                />
              )}
              <Button
                id='cfg-mct-btn-fch'
                shape="circle"
                bgColor="#FB7676"
                onClick={onClose}
                className={classes.buttonActionClose}
              >
                <CloseIcon />
              </Button>
            </div>
          </div>

          {(
            <MultiToggleButtons
              id='cfg-mct-btn-aud'
              options={options}
              tabSelected={propsTabsAuditoria.tabSelected}
              changeTabSelected={propsTabsAuditoria.changeTabAuditoriaSelected}
              classes={{ buttonsContainer: classes.buttonsTabAuditoria }}
            />
          )}

          {renderContentByTab()}

          <div className={classes.contentButtonSave}>
            <Button
              id='cfg-mct-btn-slv'
              colorCustom="green"
              onClick={handleSave}
              noShadow
              disabled={loadingSave}
              loading={loadingSave}
            >
              Salvar
            </Button>
          </div>
        </Dialog>
      </>
    );
  }
);

const styles = {
  paper: {
    width: "745px",
    maxWidth: "100%",
    height: "80vh",
    maxHeight: "100vh",
    background: "#fff",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
  paperScrollPaper: {
    maxHeight: "100%",
  },
  header: {
    padding: "8px 16px",
  },
  buttonsTabAuditoria: {
    margin: "0 16px",
  },
  buttonsHeader: {
    display: "flex",
    gap: "16px",
  },
  tituloFechar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px",
  },
  titulo: {
    fontWeight: 700,
    fontSize: "18px !important",
    color: "#333333",
  },
  content: {
    flex: 1,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
  },
  contentEdit: {
    flex: 1,
  },
  contentTabs: {
    margin: "8px 16px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    padding: "16px 16px 0 16px",
    background: "#fff",
    border: "1px solid rgba(0, 0, 0, 0.1)",
    boxShadow:
      "10px 10px 25px rgba(112, 124, 151, 0.05), 15px 15px 35px rgba(112, 124, 151, 0.05)",
    borderRadius: "10px",
    flex: 1,
    overflow: "hidden",
    minHeight: 0,
  },
  iconButtonSearch: {
    padding: "4px",
  },
  inputSearch: {
    background: "#F2F2F2",
    border: "0.5px solid rgba(220, 220, 220, 0.2)",
    borderRadius: "8px",
    fontFamily: "Poppins",
    height: "38px",
    fontSize: "14px",
  },
  contentButtonSave: {
    justifyContent: "end",
    display: "flex",
    padding: "16px 0",
    marginBlock: "auto 0",
    "& button": {
      width: "200px",
      marginRight: "32px",
    },
  },
  contentAuditoria: {
    height: "calc(100% - 137px)",
    padding: "16px 16px 0",
    overflow: "auto",
  },
  contentObservacao: {
    padding: '16px 32px',
    display: 'flex',
    flexDirection: 'column',
    overflow:"hidden",
    flex: 1,
  },
  label:{
    color: '#868686',
    fontSize: '14px',
    fontWeight: 600
  },
  observacao:{
    border: 'none',
    background: '#f2f2f2',
    width: '100%',
    flex: 1,
  },
  observacaoContainer:{
    flex: 1,
    display: 'flex',
    '& > div': {
      flex: 1,
      alignItems: 'stretch',
    },
  },
  especialidadesContainer: {
    padding: '16px',
    borderRadius: '8px',
    marginTop: '8px'
  },
  textFieldSearchInput: {
    background: '#fff',
    border: '0.5px solid rgba(220, 220, 220, 0.2)',
    borderRadius: '8px',
    height: '38px'
  },
  especialidadesListContainer: {
    padding: '16px',
    marginTop: '16px',
    background: '#f2f2f2',
    borderRadius: '8px',
    maxHeight: '300px',
    overflow: 'scroll'
  },
  especialidadesListTitle: {
    color: '#868686',
    fontSize: '14px',
    fontWeight: 600,
    margin: '0 0 12px 0'
  },
  especialidadesList: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px'
  },
  especialidadeChip: {
    border: '0.5px solid #BDBDBD',
    margin: '3px',
    display: 'flex',
    padding: '4px 8px',
    minWidth: '80px',
    background: '#F2F2F2',
    borderRadius: '100px',
    justifyContent: 'space-between',
    color: "#000",
    '& .MuiChip-deleteIcon': {
      color: '#868686',
      '&:hover': {
        color: '#000'
      }
    }
  }
};

const ModalConfiguracoesTabsWithStyles = withStyles(styles)(
  ModalConfiguracoesTabs
);

export default inject("modalConfiguracoesStore")(
  ModalConfiguracoesTabsWithStyles
);
